import { useCallback, useEffect, useState } from "react";

export function useAsync(loader, dependencies = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const reload = useCallback(async () => {
    setLoading((current) => current && data === null);
    setError("");
    try {
      const result = await loader();
      setData(result);
      return result;
    } catch (caught) {
      setError(caught.message || "No se ha podido cargar.");
      return null;
    } finally { setLoading(false); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
  useEffect(() => { reload(); }, [reload]);
  return { data, setData, loading, error, reload };
}
